import { AfterViewChecked, Component, ElementRef, EventEmitter, inject, Input, Output } from '@angular/core';

import { handleDropdownMenuContainerKeydown, showDropdownAndFocusMenuItem } from 'app/shared/utils/dropdown-menu-keyboard.util';

const menuPopupType = 'menu';

@Component({
  selector: 'kh-primary-dropdown',
  styleUrls: ['./primary-dropdown.component.less'],
  templateUrl: './primary-dropdown.component.html',
  standalone: false
})
export class PrimaryDropdownComponent<TItem> implements AfterViewChecked {
  private static nextId = 0;

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  private readonly dropdownId = PrimaryDropdownComponent.nextId++;

  public readonly buttonId = `primary-dropdown-button-${this.dropdownId}`;
  public readonly menuId = `primary-dropdown-menu-${this.dropdownId}`;

  @Input() public items: TItem[] = [];
  @Input() public getName!: (item: TItem) => string | undefined;
  @Input() public selectedItem: TItem | unknown;
  @Input() public disabled = false;
  @Input() public placeHolder = '';
  @Input() public validationMessages: string[] = [];
  @Input() public displayErrors = false;

  @Output() public readonly itemClick = new EventEmitter<TItem>();

  public ngAfterViewChecked(): void {
    this.configureDropdownButton();
  }

  public onItemClick(item: TItem): void {
    this.selectedItem = item;
    this.itemClick.emit(item);
  }

  public resolveName(item: TItem | unknown): string {
    return item ? this.getName(item as TItem) ?? '' : this.placeHolder;
  }

  public onToggleArrowKeydown(event: KeyboardEvent, dropdown: { show(): void }, focusLastItem: boolean): void {
    showDropdownAndFocusMenuItem(event, () => dropdown.show(), focusLastItem);
  }

  public onMenuKeydown(event: KeyboardEvent, dropdown: { hide(): void }, toggleButton: HTMLElement): void {
    handleDropdownMenuContainerKeydown(event, () => dropdown.hide(), toggleButton);
  }

  private configureDropdownButton(): void {
    const dropdownButton = this.elementRef.nativeElement.querySelector<HTMLElement>(`#${this.buttonId}`);

    dropdownButton?.setAttribute('aria-haspopup', menuPopupType);
  }
}
